module.exports = __webpack_public_path__ + "static/media/profile-pic.3c897afb.webp";